import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles, withTheme } from '@material-ui/core/styles';

const styles = () => ({
  Entry: {
    padding: '7px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    webkitTouchCallout: 'none',
    webkitUserSelect: 'none',
    khtmlUserSelect: 'none',
    mozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  date: {
    minWidth: '110px',
    minHeight: '30px',
    padding: '0px',
    marginLeft: '5px',
    marginRight: '5px',
  },
  details: {
    padding: '0px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  detail: {
    display: 'block',
    margin: '3px',
  },
  key: {
    margin: '2px',
  },
});

export function Entry(props) {
  const {
    date, details, style, onDateSelected, classes, focused, theme,
  } = props;

  return (
    <div
      className={classes.Entry}
      style={style}
    >
      <Button
        onClick={() => onDateSelected(date)}
        className={classes.date}
        style={{
          backgroundColor: focused ? theme.logbook.palette.timeMarker : 'inherit',
          color: focused ? 'white' : 'black',
        }}
        variant={focused ? 'raised' : 'text'}
      >
        {date.format()}
      </Button>
      <div className={classes.details}>
        {details.map(detail => (
          <span key={detail.key} className={classes.detail}>
            <b className={classes.key}>
              {`${detail.key}:`}
            </b>
            <span className={classes.value}>
              {detail.value}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}

Entry.propTypes = {
  date: PropTypes.shape().isRequired,
  details: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  classes: PropTypes.shape().isRequired,
  style: PropTypes.shape(),
  onDateSelected: PropTypes.func,
  focused: PropTypes.bool.isRequired,
  theme: PropTypes.shape().isRequired,
};

Entry.defaultProps = {
  style: {},
  onDateSelected: () => {},
};

export default withTheme()(withStyles(styles)(Entry));



// WEBPACK FOOTER //
// ./src/layout/logbook/Entry.jsx